import useApi from '../utils/axios-pettitions';
import { newToast } from '../components';
import { SysI_RemisionesExternasPacientesDetalle } from '../types/types.externalRemissions';

export const useApiExternalRemisions = () => {
  const { runApi } = useApi();

  //#region Remisiones Externas

  /**
   * Obtener remisiones externas filtradas por fecha o id
   * @param inicio Fecha de inicio (opcional)
   * @param fin Fecha de fin (opcional)
   * @param id ID de la remisión (opcional)
   */
  const getByFilter = async (inicio?: Date | null, fin?: Date | null, id?: number | null) => {
    const params: any = {};
    if (inicio) params.inicio = inicio.toISOString();
    if (fin) params.fin = fin.toISOString();
    if (id) params.id = id;

    return runApi('ExternalRemisions/GetByFilter', 'GET', params, null).then((res) => {
      if (res.internalCode >= 200) {
        
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  //#endregion

  //#region Laboratorios Remisiones Externas

  /**
   * Obtener todos los laboratorios externos
   */
  const getExternalLaboratories = async () => {
    return runApi('ExternalRemisions/GetExternalLaboratory', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  /**
   * Crear un nuevo laboratorio externo
   * @param data Datos del laboratorio externo
   */
  const createExternalLaboratory = async (data: any) => {
    return runApi('ExternalRemisions/CreateExternalLaboratory', 'POST', null, data).then((res) => {
      if (res.internalCode >= 200) {
        return null;
      } else if (res.internalCode === 101) {
        newToast('SUCCESS', res.message || 'Laboratorio creado correctamente', 3);
        return res.data;
      }
      return null;
    });
  };

  /**
   * Eliminar un laboratorio externo
   * @param id ID del laboratorio a eliminar
   */
  const deleteExternalLaboratory = async (id: number) => {
    return runApi('ExternalRemisions/DeleteExternalLaboratory', 'POST', { id }, null).then((res) => {
      if (res.internalCode >= 200) {
        return false;
      } else if (res.internalCode === 101) {
        newToast('SUCCESS', res.message || 'Laboratorio eliminado correctamente', 3);
        return true;
      }
      return false;
    });
  };

  /**
   * Actualizar un laboratorio externo
   * @param data Datos del laboratorio a actualizar
   * @param id ID del laboratorio
   */
  const updateExternalLaboratory = async (data: any, id: number) => {
    return runApi('ExternalRemisions/UpdateExternalRemision', 'POST', { id }, data).then((res) => {
      if (res.internalCode >= 200) {
        return null;
      } else if (res.internalCode === 101) {
        newToast('SUCCESS', res.message || 'Laboratorio actualizado correctamente', 3);
        return res.data;
      }
      return null;
    });
  };

  //#endregion

  //#region Remisiones Externas - Pacientes y Detalles

  /**
   * Obtener remisiones externas por filtros (fecha inicio, fecha fin, id)
   * @param inicio Fecha de inicio (opcional)
   * @param fin Fecha de fin (opcional)
   * @param id ID de la remisión (opcional)
   */
  const getExternalRemisionByFilters = async (inicio?: Date | null, fin?: Date | null, id?: number | null) => {
    const params: any = {};
    if (inicio) params.inicio = inicio.toISOString();
    if (fin) params.fin = fin.toISOString();
    if (id) params.id = id;

    return runApi('ExternalRemisions/GetExternalRemisionByFilters', 'GET', params, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  /**
   * Obtener pacientes de una remisión externa
   * @param idRm ID de la remisión externa
   */
  const getExternalRemisionPatients = async (idRm: number) => {
    return runApi('ExternalRemisions/GetExternalRemisionPatients', 'GET', { idRm }, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  /**
   * Obtener detalles de pacientes de una remisión externa
   * @param idRmPc ID del paciente de la remisión externa
   */
  const getExternalRemisionPatientsDetails = async (idRmPc: number) => {
    return runApi('ExternalRemisions/GetExternalRemisionPatientsDetails', 'GET', { idRmPc }, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  /**
   * Actualizar pacientes de una remisión externa
   * @param IdPc ID del paciente
   * @param idRm ID de la remisión externa
   */
  const updateExternalRemisionPatients = async (IdPc: number, idRm: number) => {
    return runApi('ExternalRemisions/UpdateExternalRemisionPatients', 'POST', { IdPc, idRm }, null).then((res) => {
      if (res.internalCode >= 200) {
        return null;
      } else if (res.internalCode === 101) {
        newToast('SUCCESS', res.message || 'Paciente actualizado correctamente', 3);
        return res.data;
      }
      return null;
    });
  };

  /**
   * Actualizar detalles de pacientes de una remisión externa
   * @param data Datos del detalle del paciente
   * @param id ID del detalle
   */
  const updateExternalRemisionPatientsDetails = async (data: SysI_RemisionesExternasPacientesDetalle, id: number) => {
    return runApi('ExternalRemisions/UpdateExternalRemisionPatientsDetails', 'POST', { id }, data).then((res) => {
      if (res.internalCode >= 200) {
        return null;
      } else if (res.internalCode === 101) {
        newToast('SUCCESS', res.message || 'Detalle actualizado correctamente', 3);
        return res.data;
      }
      return null;
    });
  };

  /**
   * Eliminar una remisión externa
   * @param id ID de la remisión externa
   */
  const deleteRemisionExterna = async (id: number) => {
    return runApi('ExternalRemisions/DeleteRemisionExterna', 'POST', { id }, null).then((res) => {
      if (res.internalCode >= 200) {
        return false;
      } else if (res.internalCode === 101) {
        newToast('SUCCESS', res.message || 'Remisión externa eliminada correctamente', 3);
        return true;
      }
      return false;
    });
  };

  /**
   * Eliminar un paciente de una remisión externa
   * @param id ID del paciente de la remisión externa
   */
  const deleteRemisionExternaPatient = async (id: number) => {
    return runApi('ExternalRemisions/DeleteRemisionExternaPatient', 'POST', { id }, null).then((res) => {
      if (res.internalCode >= 200) {
        return false;
      } else if (res.internalCode === 101) {
        newToast('SUCCESS', res.message || 'Paciente eliminado correctamente', 3);
        return true;
      }
      return false;
    });
  };

  /**
   * Eliminar un detalle de paciente de una remisión externa
   * @param id ID del detalle del paciente
   */
  const deleteRemisionExternaPatientDetail = async (id: number) => {
    return runApi('ExternalRemisions/DeleteRemisionExternaPatientDetail', 'POST', { id }, null).then((res) => {
      if (res.internalCode >= 200) {
        return false;
      } else if (res.internalCode === 101) {
        newToast('SUCCESS', res.message || 'Estudio eliminado correctamente', 3);
        return true;
      }
      return false;
    });
  };

  /**
   * Obtener monitoreo por ID de remisión externa
   * @param idRm ID de la remisión externa
   */
  const getMonitoreoByIdRm = async (idRm: number) => {
    return runApi('ExternalRemisions/GetMonitoreoByIdRm', 'GET', { idRm }, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  /**
   * Importar (confirmar) una remisión externa
   * @param id ID de la remisión externa (Re_Id)
   */
  const importRemisionExterna = async (id: number) => {
    return runApi('ExternalRemisions/ImportRemisionExterna', 'POST', { id }, null).then((res) => {
      if (res.internalCode >= 200) {
        return false;
      } else if (res.internalCode === 101) {
        newToast('SUCCESS', res.message || 'Remisión importada correctamente', 3);
        return true;
      }
      return false;
    });
  };

  //#endregion

  return {
    // Laboratorios Remisiones Externas
    getExternalLaboratories,
    createExternalLaboratory,
    deleteExternalLaboratory,
    updateExternalLaboratory,

    // Remisiones Externas
    getByFilter,
    getExternalRemisionByFilters,
    getExternalRemisionPatients,
    getExternalRemisionPatientsDetails,
    updateExternalRemisionPatients,
    updateExternalRemisionPatientsDetails,
    deleteRemisionExterna,
    deleteRemisionExternaPatient,
    deleteRemisionExternaPatientDetail,
    getMonitoreoByIdRm,
    importRemisionExterna,
  };
};
